import { createAction } from '@poa/state';

// fetching
export const fetchAccount = createAction('fetchAccount', (id) => ({ id }));
export const fetchAccountReports = createAction('fetchAccountReports', (id) => ({ id }));
export const updateAccount = createAction('updateAccount', (model) => ( model ));
export const fetchAccounts = createAction('fetchAccounts', (fetchType, sortingMap) => ({
  sortingMap
}));

export const fetchAccountSuccess = createAction('fetchAccountSuccess', data => ({
  data
}));

export const fetchAccountReportsSuccess = createAction('fetchAccountReportsSuccess', data => ({
  data
}));

export const fetchAccountFailed = createAction('fetchAccountFailed', () => ({}));
export const fetchAccountsSuccess = createAction('fetchAccountsSuccess', data => ({
  data
}));

export const fetchAccountsFailed = createAction('fetchAccountsFailed', () => ({}));

export const refreshAccounts = createAction(
  'refreshAccounts',
  (
    filter_by = null,
    page = 1,
    sort_by = [],
    search = null,
    page_size = 15,
    status = null
  ) => ({ filter_by, page, sort_by, search, page_size, status })
);


// ui
export const toggleFavorite = createAction('toggleFavorite', id => ({ id }));

export const setDates = createAction('setDates', ({ startDate, endDate }) => ({
  startDate,
  endDate
}));
 
// presets
export const saveColumnPreset = createAction('saveColumnPreset', (preset, availablePresets) => ({
  preset,
  availablePresets
}));
export const deletePreset = createAction('deletePreset', id => ({ id }));
export const changeColumnPreset = createAction('changeColumnPreset', presetId => ({ presetId }));
export const changeColumnVisibility = createAction('changeColumnVisibility', column => ({
  column
}));
export const toggleAllColumns = createAction('toggleAllColumns', () => ({}));

export const resetColumnSettings = createAction(
  'resetColumnSettings',
  ({ availablePresets, presetId }) => ({
    availablePresets,
    presetId
  })
);

export const changePresetOrder = createAction('changePresetOrder', columns => ({ columns }));
export const changeRounding = createAction('changeRounding', isDecimal => ({ isDecimal }));
export const changeSearch = createAction('changeSearch', searchClause => ({ searchClause }));


export const createShiftPeriod = createAction('createShiftPeriod', ( from, to, accountId ) => ({ from, to, accountId }));
export const createShiftPeriodSuccess = createAction('createShiftPeriodSuccess', data => ({ data }));
export const createShiftPeriodFailed = createAction('createShiftPeriodFailed', () => ({}));

export const updateShiftPeriod = createAction('updateShiftPeriod', ( operatorId, periodId, accountId ) => ({ 
  operatorId, 
  periodId, 
  accountId 
}));
export const fetchShiftTransfersSuccess = createAction('fetchShiftTransfersSuccess', data => ({ data }));
export const deleteShiftPeriod = createAction('deleteShiftPeriod', ( periodId, accountId ) => ({ 
  periodId, 
  accountId 
}));

export const fetchShiftMap = createAction('fetchShiftMap', (id) => ({ id }));
export const fetchShiftMapSuccess = createAction('fetchShiftMapSuccess', data => ({ data }));